var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00002 0.667969C4.40835 0.667969 0.666687 4.40964 0.666687 9.0013C0.666687 13.593 4.40835 17.3346 9.00002 17.3346C13.5917 17.3346 17.3334 13.593 17.3334 9.0013C17.3334 4.40964 13.5917 0.667969 9.00002 0.667969ZM12.625 11.9763C12.5833 12.0473 12.5279 12.1093 12.462 12.1587C12.3961 12.2082 12.321 12.244 12.2412 12.2642C12.1613 12.2843 12.0782 12.2884 11.9968 12.2762C11.9153 12.264 11.8371 12.2357 11.7667 12.193L9.18335 10.6513C8.54169 10.268 8.06669 9.4263 8.06669 8.68464V5.26797C8.06669 4.9263 8.35002 4.64297 8.69169 4.64297C9.03335 4.64297 9.31669 4.9263 9.31669 5.26797V8.68464C9.31669 8.98464 9.56669 9.4263 9.82502 9.5763L12.4084 11.118C12.7084 11.293 12.8084 11.6763 12.625 11.9763Z",
    fill: "#C1C1C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.837839e2c630223acac14a9840919819.svg";
export { ForwardRef as ReactComponent };